export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13963.c5486d77.jpg";